module.exports = __webpack_public_path__ + "static/img/NZ.1d883bc7.svg";